import React from 'react';
import TrackingAPI from 'api/TrackingAPI';
import UserMessageTool from 'components/ai/tools/UserMessageTool';
import styled from 'styled-components';
import Spinner  from 'ui-kit/Spinner';

const InteractiveUserMessage = ({
  tempText,
  badModelCountdownVisible,
  countdownSeconds,
  setSubscriptionModalState,
  game,
  scenario,
  dialog
}) => {
  if (!tempText) return null;

  const handleUpgradeClick = async () => {

    const analyticsData = {
      scenario: game?.alias,
      config_name: scenario?.name,
      scenario_name: game?.name,
      dialogId: dialog?.id
    };
    TrackingAPI.trackEvent('priority_overlay_upgrade_click', analyticsData);
    setSubscriptionModalState({
      isOpen: true,
      renderedForReason: 'dialog'
    });
  };

  return (
    <div>
      <div className="flex flex-col items-end rounded p-2 pr-0 text-right">
        <NamePlaceholder>
          You
        </NamePlaceholder>
        <User style={{ minWidth: 60, textAlign: 'left' }}>
          <div>
            <UserMessageTool text={tempText} />
          </div>
        </User>
      </div>

      {!badModelCountdownVisible ? (
        <SpinnerWrapper className="text-right">
          <div className="flex items-center space-x-4 pr-2">
            <span>Sending your message</span>
            <Spinner />
          </div>
        </SpinnerWrapper>
      ) : (
        <div className="flex flex-col items-end">
          <div className="mt-4 flex flex-row gap-4">
            <p className='font-["Nunito_Sans"] text-[rgb(188,192,197)]'>
              Wait <CountdownSpan>{countdownSeconds}</CountdownSpan> sec
            </p>
            <Spinner />
          </div>

          <div className="mt-4 flex w-full max-w-[411px] flex-row items-center gap-2">
            <p className='font-["Nunito_Sans"] font-normal leading-[18px] text-white'>
              For faster responses and better AI model please upgrade your plan
            </p>
            <PremiumButton
              onClick={handleUpgradeClick}
              className="h-fit flex-shrink-0 font-normal"
            >
              Buy premium
            </PremiumButton>
          </div>
        </div>
      )}
    </div>
  );
};

const User = styled.div`
  max-width: 400px;
  background: rgba(70, 55, 50, 1);
  border-radius: 8px 4px 8px 8px;
  padding: 12px;
  padding-right: 20px;
  color: white;
  position: relative;
`;

const SpinnerWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  color: rgba(169, 169, 169, 1);
  font-size: 16px;
  line-height: 18px;
  text-align: right;
`;

const CountdownSpan = styled.span`
  color: rgba(188, 192, 197, 1);
`;

const PremiumButton = styled.button`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
  border-radius: 50px;
  color: white;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  line-height: 18px;
  word-break: keep-all;
  width: fit-content;

  padding: 2px 6px;
  font-family: Nunito Sans;

  :hover {
    opacity: 0.8;
  }
`;

const NamePlaceholder = styled.div`
  font-family: Nunito Sans;
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
  color: rgba(255, 126, 85, 1);
`;

export default InteractiveUserMessage;
